import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { NavLink, Link } from 'react-router-dom';
const navigation = [{
  to: '/',
  label: 'Home',
  end: true
}, {
  to: '/services/crm-integrations',
  label: 'CRM integrations'
}, {
  to: '/services/automation',
  label: 'Automation'
}, {
  to: '/services/lead-scoring',
  label: 'Lead score model'
}, {
  to: '/contact',
  label: 'Contact'
}];
export function SiteHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="border-b border-stone-200 bg-[#f8f7f3]" data-id="element-147" data-mp="qyqgppx078no">
      <nav className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10" aria-label="Main navigation" data-id="element-148" data-mp="14x7yl7089qxo">
        <div className="flex h-20 items-center justify-between" data-id="element-149" data-mp="zvr1znos0qmw">
          <Link to="/" className="group flex items-center gap-3 text-[#172820]" onClick={() => setIsMenuOpen(false)} aria-label="Daanish home" data-id="element-150" data-mp="2gasj7kv8dz0b">
            <span className="grid h-9 w-9 place-items-center rounded-sm bg-[#172820] text-sm font-bold text-[#f8f7f3] transition-transform duration-200 group-hover:-rotate-6" style={{
            fontFamily: 'var(--font-display)'
          }} data-id="element-151" data-mp="29isavn6jc7m8">
              D
            </span>
            <span className="text-base font-semibold tracking-tight" style={{
            fontFamily: 'var(--font-display)'
          }} data-id="element-152" data-mp="2ogb9ricxg17e">
              Daanish
            </span>
          </Link>

          <div className="hidden items-center gap-6 lg:flex" data-id="element-153" data-mp="20rs0azi55idq">
            {navigation.map(item => <NavLink key={item.to} to={item.to} end={item.end} className={({
            isActive
          }) => `text-sm font-medium transition-colors ${isActive ? 'text-[#172820]' : 'text-stone-500 hover:text-[#172820]'}`} data-id="element-154" data-mp="25iqk492c8ylq">
                {item.label}
              </NavLink>)}
          </div>

          <Link to="/contact" className="hidden rounded-sm bg-[#172820] px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#286151] focus:outline-none focus:ring-2 focus:ring-[#286151] focus:ring-offset-2 sm:inline-flex" data-id="element-155" data-mp="102ogk5r35m46">
            Start a conversation
          </Link>

          <button type="button" className="grid h-10 w-10 place-items-center rounded-sm text-[#172820] focus:outline-none focus:ring-2 focus:ring-[#286151] lg:hidden" onClick={() => setIsMenuOpen(open => !open)} aria-expanded={isMenuOpen} aria-controls="mobile-navigation" aria-label={isMenuOpen ? 'Close navigation' : 'Open navigation'} data-id="element-156" data-mp="m35ffwwozb1d">
            {isMenuOpen ? <XIcon className="h-5 w-5" data-id="element-157" data-mp="22gvs3s1vn7mm" /> : <MenuIcon className="h-5 w-5" data-id="element-158" data-mp="22gccwj3m2xca" />}
          </button>
        </div>

        {isMenuOpen && <div id="mobile-navigation" className="border-t border-stone-200 py-4 lg:hidden" data-id="element-159" data-mp="2a2hi9v4enan5">
            <div className="flex flex-col gap-1" data-id="element-160" data-mp="20zygleccv42h">
              {navigation.map(item => <NavLink key={item.to} to={item.to} end={item.end} onClick={() => setIsMenuOpen(false)} className={({
            isActive
          }) => `rounded-sm px-3 py-3 text-sm font-medium ${isActive ? 'bg-[#e1eee8] text-[#172820]' : 'text-stone-600 hover:bg-stone-100 hover:text-[#172820]'}`} data-id="element-161" data-mp="250idqhwxi7om">
                  {item.label}
                </NavLink>)}
              <Link to="/contact" className="mt-2 rounded-sm bg-[#172820] px-3 py-3 text-center text-sm font-semibold text-white" onClick={() => setIsMenuOpen(false)} data-id="element-162" data-mp="3boysggkl9rdu">
                Start a conversation
              </Link>
            </div>
          </div>}
      </nav>
    </header>;
}